/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bp_pressure = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pressure`)
};

const es_bp_pressure = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presión`)
};

const de_bp_pressure = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Druck`)
};

const nl_bp_pressure = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Druk`)
};

const fr_bp_pressure = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pression`)
};

const it_bp_pressure = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pressione`)
};

const pt_br2_bp_pressure = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pressão`)
};

const pt_bp_pressure = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pressão`)
};

const ja_bp_pressure = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧力`)
};

const zh_bp_pressure = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`压力`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bp_pressure = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bp_pressure(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bp_pressure", locale)
	if (locale === "en") return en_bp_pressure(inputs)
	if (locale === "es") return es_bp_pressure(inputs)
	if (locale === "de") return de_bp_pressure(inputs)
	if (locale === "nl") return nl_bp_pressure(inputs)
	if (locale === "fr") return fr_bp_pressure(inputs)
	if (locale === "it") return it_bp_pressure(inputs)
	if (locale === "pt-BR") return pt_br2_bp_pressure(inputs)
	if (locale === "pt") return pt_bp_pressure(inputs)
	if (locale === "ja") return ja_bp_pressure(inputs)
	return zh_bp_pressure(inputs)
};